module.exports = __webpack_public_path__ + "static/media/QBC_2026_PDF.3c923cd8.pdf";